import { render, staticRenderFns } from "./DeveloperProcessorAssociations.vue?vue&type=template&id=18550dfd"
import script from "./DeveloperProcessorAssociations.vue?vue&type=script&lang=js"
export * from "./DeveloperProcessorAssociations.vue?vue&type=script&lang=js"
import style0 from "./DeveloperProcessorAssociations.vue?vue&type=style&index=0&id=18550dfd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports